'use client';

import { motion } from 'motion/react';

import { LightRays } from '@/components/light-rays';
import { dur, ease } from '@/lib/motion';

/**
 * Giriş ve kayıt panellerinin ortak zemini — React Bits "Light Rays"
 * (bileşen: components/light-rays.tsx, katman: `.auth-aside-rays`).
 *
 * Neden ayrı bir bileşen: aynı yüzey iki ekranda kullanılıyor (login-aside,
 * register-aside) ve aşağıdaki sayılar tek bir tasarım kararı. İki dosyaya
 * kopyalansaydı biri ayarlanıp diğeri unutulduğunda iki ekran sessizce
 * birbirinden ayrılırdı — kullanıcı ikisi arasında gidip geliyor, fark
 * doğrudan görünür.
 *
 * Panelin TEK dokusu: eskiden altında bir de ızgara (`.auth-aside-grid`)
 * vardı, kaldırıldı. İki doku üst üste gelince ikisi de zayıflıyordu —
 * ızgaranın düzenli çizgileri huzmenin yumuşak kenarını kesiyor, huzme de
 * ızgarayı yer yer siliyordu.
 *
 * WebGL kurulamazsa katman boş kalıyor ve panel kendi gradient'iyle duruyor;
 * eksik bir şey görünmüyor.
 */

/**
 * Huzmenin rengi — `--aqua-green-500`, markanın kendi yeşili. Seyreltilmiş bir
 * tonu değil: şaderin çıktısı zaten bu renkle ÇARPILIYOR ve huzme gücü
 * neredeyse her yerde 1'in altında, yani ekranda görünen zaten sönümlenmiş
 * hâli. Daha koyu bir yeşil verilse panelde griye düşerdi.
 */
const RAYS_COLOR = '#12e193';

export function AuthAsideRays() {
  return (
    <div className="auth-aside-rays" aria-hidden="true">
      {/* Geçiş neden AYRI bir katmanda: dış kutu gücü `opacity` ile tutuyor,
          motion ise animasyon boyunca `style="opacity"` YAZIYOR. İkisi aynı
          elemanda olsa satır içi değer CSS'i ezer ve katman kalıcı olarak %100
          güçte kalırdı.

          Geçiş panelin `asideV` sırasına bağlı değil: zemin içerikle birlikte
          belirseydi "sonra çalışmaya başladı" anı olmazdı. Süre `ambient` —
          zemin bir şey duyurmuyor, orada olduğunu fark ettiriyor. */}
      <motion.div
        className="auth-aside-rays-fade"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: dur.ambient, ease: ease.out }}
      >
        <LightRays
          className="auth-aside-rays-canvas"
          raysOrigin="top-center"
          /* Kaynak `top-center`in koyduğu yerden (kutunun %20 yukarısı)
             %5 aşağı, yani kutunun %15 yukarısına.

             Tavan %28: orada kaynak noktası kadraja GİRİYOR ve koni tepesi
             keskin bir nokta olarak görünüyor — ortam ışığı değil, sahneye
             tutulmuş bir projektör gibi duruyor. Tepe çerçevenin dışında
             kalmalı; huzmeler ne kadar genişse tepe de o kadar yukarıda
             durmalı, yoksa yelpaze üst kenarı tek bir noktadan doğuyormuş
             gibi okunuyor. */
          raysOffset={[0, 0.05]}
          raysColor={RAYS_COLOR}
          raysSpeed={0.7}
          /* Üçü birlikte huzmenin BOYUNU veriyor, tek kol yok: `lightSpread`
             koninin açısı, `rayLength` ışığın erimi (panelin GENİŞLİĞİNİN
             katı — panel dar ve uzun olduğu için 1'in epey üstünde olmalı ki
             dibe insin), `fadeDistance` sönümün başladığı mesafe. Yalnız biri
             büyütülürse ya dar ve uzun bir bıçak ya da geniş ve kısa bir leke
             çıkıyor. */
          lightSpread={1.7}
          rayLength={2.9}
          fadeDistance={1.9}
          saturation={0.85}
          followMouse
          mouseInfluence={0.08}
          noiseAmount={0.06}
          distortion={0.04}
          resolutionScale={0.85}
          /* Panel `.auth-aside` altında 1200px'in altında `display: none`.
             Kapı olmasaydı telefonda hiç görünmeyecek bir yüzey için WebGL
             bağlamı açılırdı. */
          minWidth={1200}
        />
      </motion.div>
    </div>
  );
}
